import { Dispatch } from 'redux';
import { request } from './request';

export async function sendInvitation(email: string, organization: string, organizationId: string) {
  return request('POST', '/invitation', { name, email, organization, organizationId });
}